export const ME_DEFAULT = 'assets/icon/me-default.svg';
export const ME_FIXED = 'assets/icon/me-fixed.svg';
export const ME_TRACKING = 'assets/icon/me-tracking.svg';
